import { createSelector } from '@reduxjs/toolkit';
import camelcaseKeys from 'camelcase-keys';

const getProductTypeEntitiesById = (state) => state?.types?.productTypes || {};

const getPassengerTypes = (state) => state.types?.passengerTypes || [];

const getProductTypes = createSelector(
  [getProductTypeEntitiesById],
  (productTypes) =>
    Object.values(productTypes).map((productType) => camelcaseKeys(productType))
);

const getQTVehicleTypes = (state) => state?.types?.vehicleTypes || [];

const getQTVehicleTypeById = createSelector(
  getQTVehicleTypes,
  (_, vehicleId) => vehicleId,
  (vehicleTypes, vehicleId) =>
    vehicleTypes.find((vehicleType) => vehicleType.id === vehicleId) || {}
);

export {
  getProductTypeEntitiesById,
  getPassengerTypes,
  getProductTypes,
  getQTVehicleTypes,
  getQTVehicleTypeById,
};
